import React from "react"
import rangoli from "../Assets/Images/Rangolil.png"
import './Aboutus.css'
export default function Aboutus(){
    return<div className="Aboutus">
        <img src={rangoli}/>
        
        <p>
        Srutilaya, the classical arts club of BITS Pilani, K. K. Birla Goa campus is thrilled to organize the 11th edition of Sursangam, in memory of its founder, the late Prof. Suresh Ramaswamy. Sursangam 2023 is to be held on 28th September 2023 from 4:30 pm onwards in Auditorium, BITS Goa. The performing artist is Smt. Nandini Shankar, a renowned Hindustani violinist and granddaughter of Padmabhushan N. Rajam. She will be accompanied by Sri. Abhishek Mishra on the Tabla. Sri. Mahesh Raghavan (Carnatic music fusion artist) is the Guest of Honour for the event. The concert is open and free-for-all
        </p>

        
    </div>
}